'use strict';

(function () {
  'use strict';

  libraryService.$inject = ['$http', '$q', 'baseService', 'appConfig'];
  angular.module('app.services').factory('libraryService', libraryService);

  function libraryService($http, $q, baseService, appConfig) {
    'ngInject';

    var service = {
      getEntries: getEntries,
      getYearRange: getYearRange,
      getFormDefaults: getFormDefaults,
      getLatestEntry: getLatestEntry,
      getLatestTwoEntries: getLatestTwoEntries
    };

    return service;

    ////////////////

    /**
     * Returns the entries between the given dates
     * 
     * @param {moment} from 
     * @param {moment} to 
     */
    function getEntries(from, to) {
      var params, responseTransformers;

      params = {
        date: ['gte.' + from.format(), 'lte.' + to.format()],
        order: 'date.asc'
      };

      return $http.get(appConfig.apiUrl + '/library', {
        params: params,
        cache: true,
        transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('date'))
      }).then(function (response) {
        var data = {},
            excludeKeys = ['id', 'date'];

        response.data.forEach(function (entry) {
          var keys = _.difference(Object.keys(entry), excludeKeys);

          keys.forEach(function (key) {
            if (!Array.isArray(data[key])) {
              data[key] = [];
            }

            data[key].push({ at: entry.date, value: entry[key] });
          });
        });

        return data;
      });
    }

    /**
     * Returnes the latest entry.
     */
    function getLatestEntry() {
      return baseService.getColumnMinOrMaxValue('library', 'date', false, { select: '*' }).then(function (response) {
        return response;
      });
    }

    /**
     * 
     * @param {string} path 
     * @param {string} column 
     * @param {boolean} min 
     * @param {array} extraParams 
     */
    function getLatestTwoEntries() {
      /* Merge default parameters with extraParams */
      var params = {
        order: 'date.desc',
        limit: 2
      };

      return $http.get(appConfig.apiUrl + '/library', { params: params, cache: true }).then(function (response) {
        return response.data;
        // return response.data.length == 1 ? response.data[0] : null;
      });
    }

    /**
    * 
    */
    function getFormDefaults() {
      return $q.when({
        from: moment().subtract(5, 'years').startOf('year'),
        to: moment().endOf('year')
      });
    }

    /**
     * Returns range of the years
     */
    function getYearRange() {
      return baseService.getColumnRange('library', 'date').then(function (response) {
        return {
          min: moment(response.min.date).startOf('year'),
          max: moment(response.max.date).endOf('year')
        };
      });
    }
  }
})();